export { DetailsLabel } from './DetailsLabel';
